import { ModalBody, ModalHeader } from '@stenajs-webui/modal';
import { BaseModal } from '../../../common-ui/modal/BaseModal';
import {
  BOOKING_ERROR_FORBIDDEN,
  BookingErrorModalContents,
} from '../../../use-cases/manage/details/components/BookingErrorModalContents';
import { useHasPermission } from '../../hooks/useHasPermission';
import { Information } from '../../texts';
import type { PermissionGateProps } from './PermissionGate';

export interface PermissionGateModalProps extends PermissionGateProps {
  onRequestClose: () => void;
}

export const PermissionGateModal = ({
  permission,
  onRequestClose,
  children,
}: PermissionGateModalProps) => {
  const getHasPermission = useHasPermission();

  if (!getHasPermission(permission)) {
    return (
      <BaseModal onRequestClose={onRequestClose}>
        <ModalBody>
          <ModalHeader
            onClickClose={onRequestClose}
            closeButtonAriaLabel={'Close'}
            heading={Information.NoAccessToFeatureHeading}
          />
          <BookingErrorModalContents icon={BOOKING_ERROR_FORBIDDEN.icon} />
        </ModalBody>
      </BaseModal>
    );
  }

  return children;
};
